import { useState } from "react";

const useTableSorting = (defaultSortField = "", defaultOrder = "asc") => {
  const [sortField, setSortField] = useState(defaultSortField);
  const [order, setOrder] = useState(defaultOrder);

  const handleSort = (field) => {
    if (sortField === field) {
      setOrder((prevOrder) => (prevOrder === "asc" ? "desc" : "asc"));
    } else {
      setSortField(field);
      setOrder("asc");
    }
  };

  return { sortField, order, handleSort };
};

export default useTableSorting;
